// extracted by mini-css-extract-plugin
export default {"div":"Second_div__kXE8T"};